import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  limit: 20,
  page: 1,
  total: 0,
  totalPages: 1,
};

export const eventCategoryPageSlice = createSlice({
  name: "eventCategoryPageSlice",
  initialState,
  reducers: {
    setEventCategoryPageLimit: (state, action) => {
      state.limit = action.payload;
    },
    setEventCategoryCurrentPage: (state, action) => {
      state.page = action.payload;
    },
    setEventCategoryTotalCount: (state, action) => {
      state.total = action.payload;
    },
    setEventCategoryTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
  },
});

export const {
  setEventCategoryPageLimit,
  setEventCategoryCurrentPage,
  setEventCategoryTotalCount,
  setEventCategoryTotalPages,
} = eventCategoryPageSlice.actions;

export default eventCategoryPageSlice.reducer;
